import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { Organisme } from '../../../../organisme/models/organisme';
import { OrganismeService } from '../../../../organisme/services/organisme.service';
import { ModalService } from '../../../../shared/design-system/organisms/p-modal/p-modal.service';
import { UtilisateurService } from '../../../../utilisateur/services/utilisateur.service';

@Component({
  selector: 'app-informations-administratives-form',
  templateUrl: './informations-administratives-form.component.html',
  styleUrls: ['./informations-administratives-form.component.scss'],
})
export class InformationsAdministrativesFormComponent
  implements OnInit, OnDestroy
{
  infosFacturationForm = new FormGroup({
    codeClient: new FormControl(),
    siret: new FormControl(),
    raisonSociale: new FormControl(),
    adresse: new FormControl(),
    codePostal: new FormControl(),
    ville: new FormControl(),
    telephone: new FormControl(),
    modePaiement: new FormControl(),
    emailIdNot: new FormControl(),
  });

  isModalMailMissingOpen = false;
  readonly modalId = 'MAIL_MISSING_MODAL';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly organismeService: OrganismeService,
    private readonly utilisateurService: UtilisateurService,
    private readonly modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async init() {
    this.modalService
      .getModalState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((modalId) => {
        this.isModalMailMissingOpen = modalId === this.modalId;
      });

    const organisme = await this.organismeService.getOrganismeBilling();
    this.initBillingFormValues(organisme);

    const currentUser = await this.utilisateurService.getCurrentUtilisateur();
    this.infosFacturationForm.controls.telephone.setValue(currentUser?.phone);
    this.infosFacturationForm.controls.emailIdNot.setValue(currentUser?.email);

    this.openModal(this.modalId, currentUser?.email);
  }

  openModal(modalId: string, email: string | undefined) {
    if (!email) {
      this.modalService.showModal(modalId);
    }
  }

  private initBillingFormValues(organisme: Organisme): void {
    this.infosFacturationForm.controls.siret.setValue(organisme.billing?.siret);
    this.infosFacturationForm.controls.codeClient.setValue(organisme.crpcen);
    this.infosFacturationForm.controls.raisonSociale.setValue(organisme.nom);
    this.infosFacturationForm.controls.adresse.setValue(
      `${
        organisme.billing?.addressLine1 ? organisme.billing?.addressLine1 : ``
      } ${
        organisme.billing?.addressLine2 ? organisme.billing?.addressLine2 : ``
      } ${
        organisme.billing?.addressLine3 ? organisme.billing?.addressLine3 : ``
      }`,
    );
    this.infosFacturationForm.controls.codePostal.setValue(
      organisme.billing?.postalCode,
    );
    this.infosFacturationForm.controls.modePaiement.setValue(
      organisme.billing?.paymentMethod,
    );
    this.infosFacturationForm.controls.ville.setValue(organisme?.billing?.city);
  }
}
